import {Component, Input, OnInit, NgModule, ViewEncapsulation, Injector, ChangeDetectionStrategy} from '@angular/core';
import {QueryValue} from "../../../../../services/model/queryValue";
import {FilterValue} from "../../../../../services/model/filterValue";
import {EfastFilterBaseComponent} from "../efast-filter-base.component";

@Component({
    selector: 'efast-filter-business',
    templateUrl: 'efast-filter-business.component.html',
    styleUrls: ['efast-filter-business.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class EfastFilterBusinessComponent extends EfastFilterBaseComponent implements OnInit {

    rangeToLbl: string;
    rangeTitle: string;
    errorMsg: string;
    applyBtn: string;
    applyFromValue: string = "";
    applyToValue: string = "";
    errorFound1: boolean;
    errorFound2: boolean;
    curQueryValue: QueryValue = new QueryValue();
    maxLength: number = 6;
    rangeTitleId: string;

    constructor(protected injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.title= this.cacheService.getLabelFromResource('FILTER:FILTERBusinessTitle');

        let filterValues: FilterValue[] = new Array();

        this.filterCategory.filterType = this.staticsService.getFilterType().BUSINESS;

        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl1'),
            this.staticsService.getBusinessFilter().BUSINESS_ACCOMMODATION));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl2'),
            this.staticsService.getBusinessFilter().BUSINESS_ADMIN));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl3'),
            this.staticsService.getBusinessFilter().BUSINESS_AGRICULTURE));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl4'),
            this.staticsService.getBusinessFilter().BUSINESS_ARTS));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl5'),
            this.staticsService.getBusinessFilter().BUSINESS_CONSTRUCTION));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl6'),
            this.staticsService.getBusinessFilter().BUSINESS_EDUCATION));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl7'),
            this.staticsService.getBusinessFilter().BUSINESS_FINANCE));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl8'),
            this.staticsService.getBusinessFilter().BUSINESS_HEALTH));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl9'),
            this.staticsService.getBusinessFilter().BUSINESS_INFO));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl10'),
            this.staticsService.getBusinessFilter().BUSINESS_MANAGEMENT));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl11'),
            this.staticsService.getBusinessFilter().BUSINESS_MANUFACTURE));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl12'),
            this.staticsService.getBusinessFilter().BUSINESS_MINING));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl13'),
            this.staticsService.getBusinessFilter().BUSINESS_OTHER));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl14'),
            this.staticsService.getBusinessFilter().BUSINESS_PROFESSIONAL));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl15'),
            this.staticsService.getBusinessFilter().BUSINESS_PUBLIC));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl16'),
            this.staticsService.getBusinessFilter().BUSINESS_REAL_ESTATE));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl17'),
            this.staticsService.getBusinessFilter().BUSINESS_RETAIL));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl18'),
            this.staticsService.getBusinessFilter().BUSINESS_TRANSPORTATION));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl19'),
            this.staticsService.getBusinessFilter().BUSINESS_UTILITIES));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERBusinessLbl20'),
            this.staticsService.getBusinessFilter().BUSINESS_WHOLESALE));

        this.rangeToLbl = this.cacheService.getLabelFromResource('FILTER:FILTERBusinessTo');
        this.rangeTitle = this.cacheService.getLabelFromResource('FILTER:FILTERBusinessRangeTitle');
        this.applyBtn = this.cacheService.getLabelFromResource('FILTER:FILTERBusinessApplyBtn');
        this.errorMsg = this.cacheService.getLabelFromResource('messages:msg.invalidRange');
        this.rangeTitleId = "businessCodeRangeId";

        this.filterCategory.filterValues = filterValues;

        super.ngOnInit();
    }

    protected expandClick() {
        super.expandClick();
    }

    apply() {
        this.errorFound1 = false;
        this.errorFound2 = false;
        this.applyFromValue = this.cleanField(this.applyFromValue);
        this.applyToValue = this.cleanField(this.applyToValue);
        if ((this.applyFromValue.trim().length != 0) || (this.applyToValue.trim().length != 0)) {
            if (this.applyFromValue.trim() != "*") {
                if (isNaN(Number(this.applyFromValue.trim()))) {
                    this.errorFound1 = true;
                } else {
                    if (this.applyToValue.trim().length == 0) {
                        this.applyToValue = "*";
                    }
                    if (this.applyFromValue.trim().length == 0) {
                        this.applyFromValue = "0";
                    }

                }
            }
            if (!this.errorFound1) {
                if (this.applyToValue.trim() != "*") {
                    if (isNaN(Number(this.applyToValue.trim()))) {
                        this.errorFound2 = true;
                    } else {
                        if (this.applyFromValue.trim().length == 0) {
                            this.applyFromValue = "0";
                        }
                        if (this.applyToValue.trim().length == 0) {
                            this.applyToValue = "*";
                        }
                    }
                }
            }

            if ((!this.errorFound1) && (!this.errorFound2)) {
                this.errorFound1 = false;
                this.errorFound2 = false;
                let queryValue: QueryValue = new QueryValue();
                //query value requires [ ] brackets for custom query string
                queryValue.value = "[" + this.generateDynamicQueryValue() + "]";
                queryValue.displayValue = this.generateDynamicQueryValue();

                this.curQueryValue = this.queryManagerService.updateOrAdd(this.curQueryValue, queryValue,
                    this.staticsService.getCategoryType().BUSINESS, true);
            }
        }
    }

    private generateDynamicQueryValue() : string {
        this.applyFromValue = this.applyFromValue.trim().padEnd(this.maxLength, '0');
        this.applyToValue = this.applyToValue.trim().padEnd(this.maxLength, '0');
        return this.applyFromValue +  " TO " + this.applyToValue;
    }

    //extended
    protected searchChangeEvent() {
        this.setBucket(this.applicationService.getAfsForm().facets.businesscodecat.buckets);
        super.searchChangeEvent();
        if (!this.queryManagerService.isQueryCategoryInManager(this.staticsService.getCategoryType().BUSINESS)){
            //clean yourself
            this.applyFromValue = "";
            this.applyToValue= "";
            this.errorFound1 = false;
            this.errorFound2 = false;
        }
    }

    //extended
    protected rowClick(filterValue: FilterValue) {

        super.rowClick(filterValue, true);
        
        //weird specific thing for businesscodes -- sachs
        //this code was removed for 20333 -- Cook
       // this.queryValue.value = filterValue.value + "*";
        this.queryValue.value = filterValue.value;

        this.queryManagerService.addQueryValueNoSearch(this.staticsService.getCategoryType().BUSINESSCAT, this.queryValue, true)
    }

}